import React from "react";

export const Pagination = ({data , pagina = 1, changePage}) => {

    function applyFilterByPage (e, page) {
      changePage(page);
    }

    var entity        = data.length > 0 ? data[0] : null;
    let actualpage    = pagina;

    let initialPage   = 1;
    var maxPagination = 6;
    let rango     = 0;

    const options = [];

    if (entity !== null){
        // console.log(entity);
        let totalPages    = entity.totalPages;

        if(totalPages == 1){
            return null;
        }

        if(actualpage < 1){
          actualpage = 1;
        }

        // console.log(index);
        // console.log(rango);

        if(totalPages > maxPagination){
          rango =   Number(maxPagination) + Number(actualpage);
        }else{
          rango =   totalPages;
        }

        if(rango > totalPages){
          if(totalPages > 4 && actualpage <= totalPages - 4){
            initialPage = actualpage - 3;
            rango       = Number(maxPagination) + Number(initialPage);
          }else{
            // console.log(rango);
            // console.log(totalPages);

            rango       = Number(totalPages);
            // actualpage  = Number(totalPages) - Number(maxPagination);
            initialPage = Number(totalPages) - Number(maxPagination);
          }
        }else{
          // console.log('menor');
          if(actualpage <= 4){
            initialPage = 1;
          }else{
            initialPage = actualpage - 3;
          }

          if(totalPages < maxPagination){
            rango       = totalPages;
          }else{
            rango       = Number(maxPagination) + Number(initialPage);
          }
        }
        

        // btn go to initial page
        if(actualpage > 1 && rango > 7){
          options.push(
            <li className="page-item">
              <a 
                  id={`inicio-pag`} 
                  key={`inicio-pag`} 
                  onClick={(e) => applyFilterByPage(e, `${1}`)}
                  className="page-link"
              > 
                Ini
              </a>
            </li>
          );
        }

        // btn before
        if(totalPages > 1){
          options.push(
              <li className="page-item">
                <a 
                    className="btnPrevPaginador page-link" 
                    id={0} 
                    key={0} 
                    onClick={(e) => Number(pagina) <= 1 ? "" : applyFilterByPage(e, `${Number(pagina) - 1}`)}
                >
                  <i className="fa-solid fa-chevron-left"></i>
                </a>
              </li>
          );
        }

        for(let i = initialPage; i <= rango; i++){
            options.push(
                <li className="page-item">
                  <a 
                      id={i} 
                      key={i} 
                      onClick={(e) => applyFilterByPage(e, `${i}`)}
                      className={(i.toString() === pagina.toString() ? "active" : "") + " page-link pageItem"}
                  > 
                      {i} 
                  </a>
                </li>
            );
        }

        //btn next
        if(totalPages > 1){
          options.push(
              <li className="page-item">
                <a 
                    className="btnNextPaginador page-link" 
                    id={entity.totalPages+1} 
                    key={entity.totalPages+1} 
                    onClick={(e) => entity.totalPages.toString() === pagina.toString() ? "" : applyFilterByPage(e, `${Number(pagina) + 1}`)}
                >
                  <i className="fa-solid fa-chevron-right"></i>
                </a>
              </li>
          );
        }

        // btn go to final page
        if(rango < totalPages){
          options.push(
            <li className="page-item">
              <a 
                className="page-link"
                id={totalPages} 
                key={totalPages} 
                onClick={(e) => applyFilterByPage(e, `${totalPages}`)}
              > 
                Fin
              </a>
            </li>
          );
        }

        // console.log(options);
    }

    return (
        <div className="d-flex justify-content-end">
          <nav aria-label="Page navigation example f-normal">
            <ul className="pagination px-0">
              {options}
            </ul>
          </nav>
        </div>
    );
}